import { Unsubscribe } from "firebase/firestore";
import { StateCreator } from "zustand";
import { analyticsRepository } from "@/repositories/analytics";

export interface ListenersSlice {
  setUserListener: (listener: Unsubscribe) => void;
  userListener: Unsubscribe | undefined;
  unsubscribeUserListener: () => void;
  setShopListener: (listener: Unsubscribe) => void;
  shopListener: Unsubscribe | undefined;
  unsubscribeShopListener: () => void;
  setOtherListener: (key: string, listener: Unsubscribe) => void;
  otherListeners: { [key: string]: Unsubscribe | undefined };
  unsubscribeOtherListener: (key: string) => void;
  unsubscribeOtherListeners: () => void;
}

const initialSlice: ListenersSlice = {
  setUserListener: () => {},
  userListener: undefined,
  unsubscribeUserListener: () => {},
  setShopListener: () => {},
  shopListener: undefined,
  unsubscribeShopListener: () => {},
  setOtherListener: () => {},
  otherListeners: {},
  unsubscribeOtherListener: () => {},
  unsubscribeOtherListeners: () => {},
};

export const createListenersSlice: StateCreator<
  ListenersSlice,
  [],
  [],
  ListenersSlice
> = (set, get) => ({
  ...initialSlice,
  setUserListener: (listener: Unsubscribe) => {
    analyticsRepository.logAnalyticsEvent("set_user_listener");
    get().unsubscribeUserListener();
    set({ userListener: listener });
  },
  unsubscribeUserListener: () => {
    const unsubscribe = get().userListener;
    if (unsubscribe) unsubscribe();
    set({ userListener: undefined });
  },
  setShopListener: (listener: Unsubscribe) => {
    analyticsRepository.logAnalyticsEvent("set_shop_listener");
    get().unsubscribeShopListener();
    set({ shopListener: listener });
  },
  unsubscribeShopListener: () => {
    const unsubscribe = get().shopListener;
    if (unsubscribe) unsubscribe();
    set({ shopListener: undefined });
  },
  setOtherListener: (key: string, listener: Unsubscribe) => {
    get().unsubscribeOtherListener(key);
    set({ otherListeners: { ...get().otherListeners, [key]: listener } });
  },
  unsubscribeOtherListener: (key: string) => {
    const listener = get().otherListeners[key];
    if (listener) listener();
    set({ otherListeners: { ...get().otherListeners, [key]: undefined } });
  },
  unsubscribeOtherListeners: () => {
    Object.values(get().otherListeners).forEach((listener) => {
      if (listener) listener();
    });
    set({ otherListeners: {} });
  },
});
